import styled from "styled-components";

export const Bold = styled.span`
	display: block;
	position: relative;
	font-weight: ${({ theme }) => theme.fonts.weights.bold};
`;
